import { systemStateSchema, type SystemState } from '@fuel-system/contracts';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

export type { SystemState };

const NOT_FROZEN: SystemState = { frozen: false, archive: false };

/**
 * GET /system/state (both apps): the year-management freeze flag and whether
 * this is the read-only archive environment. A 404 (endpoint not deployed
 * yet in an older environment) is treated as the not-frozen, not-archive
 * default per the rules.
 */
export function useSystemState() {
  return useQuery({
    queryKey: ['system-state'],
    queryFn: async () => {
      try {
        return await apiRequest<SystemState>('/system/state', { schema: systemStateSchema });
      } catch (error) {
        if (error && typeof error === 'object' && 'status' in error && error.status === 404) {
          return NOT_FROZEN;
        }
        throw error;
      }
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}
